<template>
  <v-dialog :model-value="true" fullscreen transition="fade-transition" @update:model-value="close" scrim="black">
    <div class="gl-overlay" @pointerdown="onPointerDown" @pointerup="onPointerUp">
      <div class="gl-top-bar">
        <v-btn icon="mdi-close" variant="text" color="white" density="comfortable" @click="close" />
        <span class="gl-counter">{{ index + 1 }} / {{ items.length }}</span>
        <span style="width:40px"></span>
      </div>

      <div class="gl-stage">
        <button v-if="items.length > 1" class="gl-nav gl-nav-prev" @click.stop="prev">
          <v-icon color="white">mdi-chevron-right</v-icon>
        </button>

        <div class="gl-media">
          <BeforeAfterSlider
            v-if="current.image_before"
            :key="'ba-' + current.id"
            :before="fileUrl(current.image_before)"
            :after="fileUrl(current.image)"
          />
          <img v-else :key="'img-' + current.id" :src="fileUrl(current.image)" class="gl-single-img" alt="" />
        </div>

        <button v-if="items.length > 1" class="gl-nav gl-nav-next" @click.stop="next">
          <v-icon color="white">mdi-chevron-left</v-icon>
        </button>
      </div>

      <div v-if="current.title || current.tag" class="gl-caption">
        <div v-if="current.title" class="gl-title">{{ current.title }}</div>
        <v-chip v-if="current.tag" size="small" class="mt-1" variant="flat" color="white">
          <span style="color:#111">{{ current.tag }}</span>
        </v-chip>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import BeforeAfterSlider from './BeforeAfterSlider.vue';

export default {
  name: 'GalleryLightbox',
  components: { BeforeAfterSlider },
  props: {
    items: { type: Array, required: true },
    startIndex: { type: Number, default: 0 },
  },
  emits: ['close'],
  data() {
    return {
      index: this.startIndex,
      touchStartX: null,
    };
  },
  computed: {
    current() { return this.items[this.index] || {}; },
  },
  methods: {
    fileUrl(path) { return this.$store.state.fileBaseUrl + path; },
    next() { this.index = (this.index + 1) % this.items.length; },
    prev() { this.index = (this.index - 1 + this.items.length) % this.items.length; },
    close() { this.$emit('close'); },
    onPointerDown(e) { this.touchStartX = e.clientX; },
    onPointerUp(e) {
      if (this.touchStartX === null) return;
      const diff = e.clientX - this.touchStartX;
      this.touchStartX = null;
      if (Math.abs(diff) < 40 || this.items.length < 2) return;
      if (diff < 0) this.next();
      else this.prev();
    },
  },
};
</script>

<style scoped>
.gl-overlay {
  position: fixed;
  inset: 0;
  background: #000;
  display: flex;
  flex-direction: column;
  z-index: 3000;
}
.gl-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px calc(8px + env(safe-area-inset-top));
  flex-shrink: 0;
}
.gl-counter { color: rgba(255,255,255,0.85); font-size: 13px; font-weight: 600; }

.gl-stage {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}
.gl-media {
  width: 100%;
  height: 100%;
  position: relative;
}
.gl-single-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.gl-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.gl-nav-prev { right: 10px; }
.gl-nav-next { left: 10px; }

.gl-caption {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  text-align: center;
}
.gl-title { color: #fff; font-size: 14px; font-weight: 600; }
</style>
